import  { useState , useCallback , useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchCart , removeProductFromCart } from '../../store/actions/index';
import { formatCurrency } from '../../shared/utility';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import styled from 'styled-components';
import CartItem from './CartItem/CartItem';
import { useHistory } from 'react-router-dom';


const CartModule = styled.div`
    display: inline-flex;
    align-items: center;
    position: relative;
    margin-right: 20px;
    height: 100%;
`
const CartIcon = styled.div`
    color: #fff;
    position: relative;
    cursor: pointer;
    `
const CartIconLabel = styled.span`
    width           : 16px;
    height          : 16px;
    line-height     : 16px;
    border-radius   : 50%;
    background-color: #e01a1a;
    color           : #fff;
    font-size       : 10px;
    font-weight     : 400;
    text-align      : center;
    position        : absolute;
    top             : -7px;
    left            : 12px;
    `
const CartMessage = styled.p`
    color: #a0a0a0;
    font-size: 16px
    `
const CartTotal = styled.p`
    color: #9b9b9b;
    font-size: 18px;
    font-weight: 400;
    margin:0 0 20px;
    text-align: left;
    display: flex;
    align-items: center;
    text-transform: capitalize;
    `
const CartPrice = styled.i`
    color: #333;
    font-size: 18px;
    margin:0;
    text-align: left;
    font-weight: 700;
    `
const CartWrapper = styled.div`
    padding: 25px;
    background-color: #fff;
    width: 300px;
    position: absolute;
    box-shadow: 2px 1px 9px 0px #00000091;
    left:50%;
    transform: translateX(-50%);
    opacity: ${ props => props.opened ? '1' :  '0' };
    transform: ${ props => props.opened ? 'translate( -50% ,0)' :  'translateY(-50% ,10px)' };
    visibility: ${ props => props.opened ? 'visible' :  'hidden' };
    transition: 0.3s ease-in-out;
    border-radius: 0 0 12px 12px;
    top: 100%;
`

const Button = styled.button`
    width: 100%;
    font-size:17px;
    padding:15px 30px;
    background-color: #f44040;
    color: #fff;
    border:0;
    outline: none;
    cursor: pointer;
    text-transform: capitalize;
    border-radius: 4px;
    transition: 0.3s ease-in-out;
    &:hover,&:active,&:focus {
        background-color: #e01a1a;
    }
`

const CartButton = props => {

    const history = useHistory();

    const [ cartOpened , setCartOpened ] = useState(false);
    const [ totalPrice , setTotalPrice ] = useState(0);

    const { fetchCartHandler , cartItems , cartQuantity ,  removeProduct } = props;
    
    
    useEffect(() => {
        fetchCartHandler()
    }, [ fetchCartHandler ]);
    
    
    const totalPriceHandler = useCallback( ( ) => {
        const updatePrice = cartItems.reduce((sum, entry) => {
            return sum + ( (entry.priceCents * entry.quantity ) / 100 )
        }, 0)
        setTotalPrice(updatePrice);
    }, [ cartItems ])

    useEffect(() => {
        totalPriceHandler();
    }, [ cartItems , cartQuantity , totalPriceHandler]);

    const toggleCartHandler = useCallback( ( ) => {
        setCartOpened( prevState => !prevState );
    },[ ])
    const viewCartHandler = useCallback( ( ) => {
        setCartOpened( prevState => !prevState );
        history.push('/cart');
    },[ history ])
    const removeItemHandler = useCallback( ( id ) => {
        removeProduct(id);
    },[ removeProduct ])

    let fetchedCartItems = [];

    if ( cartItems.length === 0 ) {
        fetchedCartItems = <CartMessage>Buy Something</CartMessage>
    }
    else {
        fetchedCartItems = cartItems.map( item => {
            return <CartItem key={item.id} id={item.orderId} img={ '#'+ item.imageColor} name={item.name} 
            price= {formatCurrency( ( item.priceCents / 100 ) * item.quantity )} quantity={item.quantity} remove={removeItemHandler} />
        })
    }

    return (
        <CartModule>
            <CartIcon onClick= {toggleCartHandler}>
                <ShoppingCartOutlinedIcon />
                <CartIconLabel>{cartQuantity ? cartQuantity : 0 }</CartIconLabel>
            </CartIcon>
            <CartWrapper opened= {cartOpened}>
                {!cartItems ? <p>Your Cart Is Empty</p> : null}
                {fetchedCartItems}
                {cartItems.length !== 0 ? <CartTotal>total: <CartPrice>{formatCurrency(totalPrice)}</CartPrice></CartTotal> : null}
                <Button onClick= {viewCartHandler}>view cart</Button>
            </CartWrapper>
        </CartModule>
    )
}

const mapStateToProps = state =>{
    return {
        cartItems: state.cart.cartItems,
        cartQuantity: state.cart.cartQuantity,
    }
}
const mapDispatchToProps = dispatch =>{
    return {
        fetchCartHandler : ( ) => dispatch( fetchCart( ) ),
        removeProduct: ( id ) => dispatch( removeProductFromCart( id ) )
    }
}


export default connect( mapStateToProps , mapDispatchToProps )(CartButton);